<template>
  <div 
    class="home d-flex flex-column justify-content-center clickable"
    @click="navTo('museum')"
  >
    <div class="intro-container">
      <h1
        class="tangerine-bold"
      >Museum Pankow</h1>
      <img src="/img/Museum-Pankow-Logo-rot.png">
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex'


export default {
  name: 'home',
  components: {

  },
  data () {
    return {

    }
  },
  methods: {
    navTo(target) {
        this.$router.push(`/${target}`)
    },
  },
  computed: {
    ...mapGetters({
      selectedVideo: 'getSelectedVideo',
      player: 'getPlayerStatus',
      pagesData: 'getPagesData',
      modalState: 'getModalState'
    })
  },
  created () {
    this.$store.state.selectedVideo = null
  }
}
</script>
<style lang="scss" scoped>
@import '@/scss/custom.scss';
.home {
  min-height: 100vh;
  background-image: url('/img/museum-pankow-back-1400x900.jpg');
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  .intro-container {
    h1 {
      width: 100%;
      font-size: $font-title-xl;
      color: $white-broken;
      text-shadow: 6px 8px 10px $grey-dark;
      text-align: center;
      margin-top: 18rem;
    }
   img{
     display: block;
     max-width: 11rem;
     margin: 6rem auto;
   } 
  }
}
</style>